<ng-template #emailTemplate let-insert="insert" let-kind="kind">
  <rt-redactor-inserts-email-templates
    *ngIf="hasStep(kind)"
    [insideTemplate]="emailTemplateInsideTemplate"
    [step]="state.step"
    [hasBackAction]="hasBack()"
    [selected]="isSelected(insert)"
    [kind]="kind"
    (stepInside)="setStep(kind)"
    (back)="setStep('insertion-list')"
    (settings)="goToSettings($event)"
    (closeDropdown)="closeDropdown()"
    (emailTemplateChoose)="emailTemplateChoose.emit($event); closeDropdown()"
    (saveAsTemplate)="saveAsTemplate.emit(); closeDropdown()"
  >
  </rt-redactor-inserts-email-templates>
</ng-template>

<rt-dropdown (click)="$event.preventDefault()" rtScrollbar class="dropdown insert-dropdown">
  <rt-dropdown-header *ngIf="state.step === 'insertion-list'" [fullWidthTitle]="true">
    {{ 'app.redactor_inserts.dropdown.header' | translate }}
  </rt-dropdown-header>

  <ng-container
    *ngFor="let insert of state.availableInserts; trackBy: trackByInsert"
    [ngSwitch]="insert"
  >
    <ng-container *ngSwitchCase="'email-templates'">
      <ng-container
        [ngTemplateOutlet]="emailTemplate"
        [ngTemplateOutletContext]="{ insert: insert, kind: InsertsEmailKind.EmailTemplate }"
      >
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'event-invitation-templates'">
      <ng-container
        [ngTemplateOutlet]="emailTemplate"
        [ngTemplateOutletContext]="{ insert: insert, kind: InsertsEmailKind.EventInvitation }"
      >
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'questionnaires-templates'">
      <rt-redactor-inserts-questionnaires
        *ngIf="hasStep('questionnaires-templates')"
        [step]="state.step"
        [hasBackAction]="hasBack()"
        [selected]="isSelected(insert)"
        (stepInside)="setStep('questionnaires-templates')"
        (back)="setStep('insertion-list')"
        (settings)="goToSettings($event)"
        (closeDropdown)="closeDropdown()"
        (insertLink)="insertLink.emit($event)"
      >
      </rt-redactor-inserts-questionnaires>
    </ng-container>
    <ng-container *ngSwitchCase="'schedules'">
      <rt-redactor-inserts-scheduler
        *ngIf="hasStep('schedules')"
        [step]="state.step"
        [hasBackAction]="hasBack()"
        [selected]="isSelected(insert)"
        (stepInside)="setStep('schedules')"
        (back)="setStep('insertion-list')"
        (settings)="goToSettings($event)"
        (closeDropdown)="closeDropdown()"
        (insertLink)="insertLink.emit($event)"
      >
      </rt-redactor-inserts-scheduler>
    </ng-container>
    <ng-container *ngSwitchCase="'gdpr-links'">
      <rt-redactor-inserts-gdpr
        *ngIf="hasStep('gdpr-links')"
        [step]="state.step"
        [selected]="isSelected(insert)"
        [hasBackAction]="hasBack()"
        (stepInside)="setStep('gdpr-links')"
        (back)="setStep('insertion-list')"
        (settings)="goToSettings($event)"
        (closeDropdown)="closeDropdown()"
        (insertLink)="insertLink.emit($event)"
      >
      </rt-redactor-inserts-gdpr>
    </ng-container>
    <ng-container *ngSwitchCase="'gdpr-links-without-consent'">
      <rt-redactor-inserts-gdpr
        *ngIf="hasStep('gdpr-links-without-consent')"
        [step]="state.step"
        [selected]="isSelected(insert)"
        [hasBackAction]="hasBack()"
        [isConsentRequestShow]="false"
        (stepInside)="setStep('gdpr-links-without-consent')"
        (back)="setStep('insertion-list')"
        (settings)="goToSettings($event)"
        (closeDropdown)="closeDropdown()"
        (insertLink)="insertLink.emit($event)"
      >
      </rt-redactor-inserts-gdpr>
    </ng-container>
    <ng-container *ngSwitchCase="'integrations-kununu'">
      <rt-redactor-inserts-integrations-kununu
        *ngIf="hasStep('integrations-kununu')"
        [step]="state.step"
        [selected]="isSelected(insert)"
        [hasBackAction]="hasBack()"
        (stepInside)="setStep('integrations-kununu')"
        (back)="setStep('insertion-list')"
        (closeDropdown)="closeDropdown()"
        (insertLink)="insertLink.emit($event)"
      >
      </rt-redactor-inserts-integrations-kununu>
    </ng-container>
  </ng-container>
</rt-dropdown>
